import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿En cuánto tiempo veo resultados?',
    a: 'Primeros cambios en semanas 3-4. Vellos nuevos entre el Día 60 y 90. Resultados consolidados en el Día 90.'
  }, {
    q: '¿Cuánto tiempo por día me lleva?',
    a: '20-35 minutos por día. El Bono 5 incluye rutinas express de 5, 10 y 20 minutos.'
  }, {
    q: '¿Qué pasa si ya probé cosas naturales antes?',
    a: 'Probablemente usaste concentraciones muy bajas. Nuestros tónicos tienen 10-20x más concentración que un té casero común.'
  }, {
    q: '¿Sirve si ya estoy muy pelado?',
    a: 'Si todavía hay algún vello fino, hay folículo activo y hay respuesta posible. Si no hay ningún vello, los folículos ya cerraron.'
  }, {
    q: '¿Lo puedo hacer si uso Minoxidil?',
    a: 'Sí, son compatibles. Si decidís dejar el Minoxidil, hacelo gradualmente.'
  }, {
    q: '¿Qué pasa si soy alérgico?',
    a: 'El Bono 4 tiene tests de sensibilidad y sustitutos seguros para cada ingrediente.'
  }, {
    q: '¿Funciona para la barba?',
    a: 'Sí. Los tónicos y masajes se pueden aplicar en la zona de la barba.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 text-center" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-48">
            LAS PREGUNTAS QUE SÉ QUE ESTÁS HACIENDO
          </h2>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-49">
          {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-50" />)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-green-50 p-8 rounded-lg border border-green-200 text-center" data-id="element-51">
          <h3 className="text-2xl font-bold text-gold mb-6" data-id="element-52">
            EL ÚNICO REQUISITO REAL
          </h3>
          <div className="space-y-4 text-gray-600 text-lg" data-id="element-53">
            <p className="font-bold text-gray-900 text-xl py-2" data-id="element-54">
              Requiere constancia.
            </p>
            <p data-id="element-55">
              20 minutos por día, 90 días seguidos. Ese es el único requisito.
              El pibe que lo hace, llega con resultados.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg bg-gray-50 overflow-hidden" data-id="element-56">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-57">
        <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-58">{question}</span>
        <span className="text-gold text-2xl shrink-0" data-id="element-59">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      <AnimatePresence data-id="element-60">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-61">
            <div className="px-6 pb-4 text-gray-600 leading-relaxed border-t border-gray-200 pt-4" data-id="element-62">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}